import { render, staticRenderFns } from "./AdditionalProductTable.vue?vue&type=template&id=a803456c&scoped=true"
import script from "./AdditionalProductTable.vue?vue&type=script&lang=js"
export * from "./AdditionalProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a803456c",
  null
  
)

export default component.exports